import { VendorModel, VendorModels, VendorSelectionType } from '../Content/Vendors/vendorTypes';
import { ActiveVendorDetailModel } from '../Models/ActiveVendorsModel';
import { IabVenderListModel } from '../Models/IabVendorListModel';
import { GetActiveVendors, GetVendorList } from '../Repositories/AssetRepositoryAsync';

const isEssentialVendor = (activeVendor: ActiveVendorDetailModel): boolean => activeVendor.id === 4;

const GetAllIds = (vendorListModel: IabVenderListModel) => {
  return {
    purposeIds: Object.keys(vendorListModel.purposes).map((k) => vendorListModel.purposes[k].id),
    featureIds: Object.keys(vendorListModel.features).map((k) => vendorListModel.features[k].id),
    specialPurposeIds: Object.keys(vendorListModel.specialPurposes).map((k) => vendorListModel.specialPurposes[k].id),
    specialFeatureIds: Object.keys(vendorListModel.specialFeatures).map((k) => vendorListModel.specialFeatures[k].id),
    legIntPurposeIds: Object.keys(vendorListModel.purposes).map((k) => vendorListModel.purposes[k].id),
  };
};

export const getVendors: () => Promise<VendorModels> = async () => {
  const activeVendors = await GetActiveVendors();
  const vendorList = await GetVendorList();
  const vendors = Object.keys(vendorList.vendors).map((k) => vendorList.vendors[k]);

  const vendorsModelForIab = activeVendors.iab?.map((activeVendor) => {
    const vendor = vendors.filter((vendor) => vendor.id === activeVendor.id)[0];

    return new VendorModel({
      isIabVendor: true,
      vendorId: vendor.id,
      name: vendor.name,
      policyUrl: vendor.policyUrl,
      cookieMaxAgeSeconds: vendor.cookieMaxAgeSeconds,
      purposeIds: vendor.purposes,
      featureIds: vendor.features,
      specialPurposeIds: vendor.specialPurposes,
      specialFeatureIds: vendor.specialFeatures,
      legIntPurposeIds: vendor.legIntPurposes,
    });
  });

  const allIds = GetAllIds(vendorList);

  const vendorsModelForNonIab = activeVendors['non-iab']?.map((activeVendor) => {
    return new VendorModel({
      isIabVendor: false,
      vendorId: activeVendor.id,
      name: activeVendor.friendlyName,
      cookieMaxAgeSeconds: 3600,
      policyUrl: activeVendor.privacyPolicyLink,
      purposeIds: allIds.purposeIds,
      featureIds: allIds.featureIds,
      specialPurposeIds: allIds.specialPurposeIds,
      specialFeatureIds: allIds.specialFeatureIds,
      isEssential: isEssentialVendor(activeVendor),
    });
  });

  let results = [...(vendorsModelForIab ?? []), ...(vendorsModelForNonIab ?? [])];

  results = results.map((vendor: VendorModel) => {
    //TODO dont do this if already saved!!
    vendor.selections = [];

    const isSelectionApplicable = (v: VendorSelectionType) => vendor?.getToggleOptions().indexOf(v) >= 0 ?? false;

    if (vendor.isEssential) {
      vendor.selections = vendor.getToggleOptions();
    } else if (isSelectionApplicable(VendorSelectionType.LegitimateInterest)) {
      vendor.selections.push(VendorSelectionType.LegitimateInterest);
    }

    return vendor;
  });

  const sortVendors = (currentVendor: VendorModel, nextVendor: VendorModel): number => {
    if (currentVendor.name < nextVendor.name) return -1;
    if (currentVendor.name > nextVendor.name) return 1;
    return 0;
  };

  return new VendorModels([...results].sort(sortVendors));
};
